import React from 'react';
import '../scss/contactus.scss';

function employeeHeader() {
  return (
    <tr>
      <th scope="col">Employee</th>
      <th scope="col">Title</th>
      <th scope="col">E-Mail Address</th>
      <th scope="col">Phone</th>
    </tr>
  )
};

function employeeRow(name, title, email, phone) {
  return (
    <tr>
      <th scope="row">{name}</th>
      <td>{title}</td>
      <td><a href={'mailto:' + email}>{email}</a></td>
      <td><a href={'tel:' + phone} className="text-nowrap">{phone}</a></td>
    </tr>
  )
}

function ContactUs() {
  return (
    <div className="contact-us">
      <div className="location-table">
        <div className="location-header d-flex flex-row align-items-center">
          <h4>Oregon Office</h4>
          <a href="https://goo.gl/maps/6w1CwRJkce3dePwM7"><p className="font-italic pl-3">View on a map</p></a>
        </div>
        <table className="table table-striped table-responsive-md table-hover">
          <thead>
            {employeeHeader()}
          </thead>
          <tbody>
            {employeeRow('David Diedrich', 'Managing Partner', 'Diedrich@electratech.com', '503-816-4956')}
          </tbody>
        </table>
      </div>
      <div className="location-table">
        <div className="location-header d-flex flex-row align-items-center">
          <h4>Washington Office</h4>
          <a href="https://goo.gl/maps/Eg3GPuYz6AUWqeZi7"><p className="font-italic pl-3">View on a map</p></a>
        </div>
        <table className="table table-striped table-responsive-md table-hover">
          <thead>
            {employeeHeader()}
          </thead>
          <tbody>
            {employeeRow('Terry Edgar', 'Managing Partner', 'Terry@electratech.com', '425-890-6078')}
            {employeeRow('TBD', 'Field Sales Engineer', '', '')}
          </tbody>
        </table>
      </div>
      <div className="location-table">
        <div className="location-header d-inline-block">
          <h4>Canadian Office</h4>
        </div>
        <table className="table table-striped table-responsive-md table-hover">
          <thead>
            {employeeHeader()}
          </thead>
          <tbody>
            {employeeRow('Alphon Tan', 'Field Sales Engineer', 'Alphon@electratech.com', '604-600-9038')}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ContactUs;
